import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialuiModule } from '../core/themes/modules/materialui.module';
import { DialogComponent } from './components/dialog/dialog.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { BtnIconRightComponent } from './components/btn-icon-right/btn-icon-right.component';
import { SquareIconBtnComponent } from './components/square-icon-btn/square-icon-btn.component';
import { SvgIconComponent } from './components/svg-icon/svg-icon.component';
import { FloatingActionButtonComponent } from './components/floating-action-button/floating-action-button.component';
import { FlatBtnComponent } from './components/flat-btn/flat-btn.component';
import { RaisedBtnComponent } from './components/raised-btn/raised-btn.component';
import { FormInputWithIconComponent } from './components/form-input-with-icon/form-input-with-icon.component';
import { FormInputComponent } from './components/form-input/form-input.component';
import { FormInputTextComponent } from './components/form-input-text/form-input-text.component';
import { StrokedBtnComponent } from './components/stroked-btn/stroked-btn.component';
import { StrokedBtnWithIconComponent } from './components/stroked-btn-with-icon/stroked-btn-with-icon.component';
import { BasicBtnWithIconComponent } from './components/basic-btn-with-icon/basic-btn-with-icon.component';
import { SnackbarService } from './services/snackbar.service';
import { DialogService } from './services/dialog.service';
import { EntryCardComponent } from './components/entry-card/entry-card.component';
import { SimpleInputComponent } from './components/simple-input/simple-input.component';
import { SimpleInputWithIconComponent } from './components/simple-input-with-icon/simple-input-with-icon.component';
import { CheckboxComponent } from './components/checkbox-widget/checkbox-widget.component';

/* components/filters/modules/services
which will be reused and can be imported in
any other module when those items will be used */

@NgModule({
  imports: [
    // Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialuiModule
  ],
  declarations: [
    // Components
    DialogComponent,
    BackButtonComponent,
    SquareIconBtnComponent,
    SvgIconComponent,
    FloatingActionButtonComponent,
    BtnIconRightComponent,
    FlatBtnComponent,
    RaisedBtnComponent,
    FormInputWithIconComponent,
    FormInputComponent,
    FormInputTextComponent,
    StrokedBtnComponent,
    StrokedBtnWithIconComponent,
    BasicBtnWithIconComponent,
    EntryCardComponent,
    SimpleInputComponent,
    SimpleInputWithIconComponent,
    CheckboxComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [
    // Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialuiModule,
    // Compoinents
    BackButtonComponent,
    SquareIconBtnComponent,
    SvgIconComponent,
    FloatingActionButtonComponent,
    BtnIconRightComponent,
    FlatBtnComponent,
    RaisedBtnComponent,
    FormInputWithIconComponent,
    FormInputComponent,
    FormInputTextComponent,
    StrokedBtnComponent,
    StrokedBtnWithIconComponent,
    BasicBtnWithIconComponent,
    EntryCardComponent,
    SimpleInputComponent,
    SimpleInputWithIconComponent,
    CheckboxComponent
  ],
  providers: [
    // Services
    SnackbarService,
    DialogService,
  ]
})
export class SharedModule {

}
